<template>
  <div class="mx-auto w-full flex items-center " v-if="loading">
    <Spinner></Spinner>
  </div>
  <div v-else-if="!success">
    <button class="g--button" @click="unsubscribe()">Unsubscribe</button>
  </div>
  <div v-if="success">
    <p class=" text-green-800 text-sm">You have successfully unsubscribed.</p>
  </div>
  <div v-if="error">
    <p class="mt-2 text-red-800 text-sm">There was an error unsubscribing.</p>
  </div>
</template>

<script setup>
import { onMounted, useTemplateRef, ref } from 'vue';
import Spinner from './Spinner.vue';

const props = defineProps({
  email: String,
  code: String
});

const success = ref(false)
const loading = ref(false);
const error = ref(false);

const unsubscribe = () => {
  loading.value = true;
  error.value = false;
  success.value = false;
  let data = {};
  data[csrfTokenName] = csrfTokenValue;
  data['email'] = props.email;
  data['code'] = props.code;
  fetch('/actions/live-yoga-teachers/emails/unsubscribe',
      {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        if (response.success) {
          success.value = true;
        } else {
          // alert('There was an error unsubscribing. Please try again later.');
          error.value = true;
        }
        loading.value = false;
      });

}
onMounted(() => {

});
</script>